// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar user menu — INCYIA */

.incyia-user {
  position: relative;
  font-family: Lato, sans-serif;
  flex-shrink: 0;
}

.incyia-user-trigger {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  padding: 0 10px 0 6px;
  border-radius: 11px;
  border: 1px solid transparent;
  background: transparent;
  color: #0b1e2d;
  cursor: pointer;
  width: auto !important;
  transition: background 0.14s, border-color 0.14s, box-shadow 0.14s;
}

.incyia-user-trigger:hover {
  background: #f7f9fd;
  border-color: #dee4f0;
}

.incyia-user-trigger.is-open {
  background: #f7f9fd;
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);
}

.incyia-user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #00146d;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  flex-shrink: 0;
  text-transform: uppercase;
}

.incyia-user-avatar--lg {
  width: 40px;
  height: 40px;
  font-size: 13px;
}

.incyia-user-meta {
  display: none;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
  min-width: 0;
}

@media (min-width: 600px) {
  .incyia-user-meta {
    display: flex;
  }
}

.incyia-user-name {
  font-size: 16px;
  font-weight: 700;
  color: #0b1e2d;
  white-space: nowrap;
  text-transform: capitalize;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.incyia-user-role {
  margin-top: 2px;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5f7484;
  white-space: nowrap;
}

.incyia-user-caret {
  color: #8a9ba7;
  transition: transform 0.18s ease, color 0.14s;
  flex-shrink: 0;
}

.incyia-user-trigger.is-open .incyia-user-caret {
  transform: rotate(180deg);
  color: #076b5c;
}

.incyia-user-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1400;
  width: 248px;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 14px;
  box-shadow:
    0 1px 2px rgba(6, 21, 36, 0.04),
    0 18px 44px -22px rgba(0, 20, 109, 0.42);
  overflow: hidden;
  animation: incyia-user-in 0.16s ease;
}

.incyia-user-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 14px 12px;
  background: linear-gradient(180deg, #f7f9fd 0%, #fff 100%);
  border-bottom: 1px solid #eaeff7;
}

.incyia-user-head-copy {
  min-width: 0;
}

.incyia-user-head-name {
  font-size: 14.5px;
  font-weight: 700;
  color: #0b1e2d;
  text-transform: capitalize;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.incyia-user-head-role {
  margin-top: 3px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #076b5c;
}

.incyia-user-section {
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.incyia-user-foot {
  padding: 6px;
  border-top: 1px solid #eaeff7;
  background: #fafcfd;
}

.incyia-user-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100% !important;
  margin: 0;
  padding: 9px 10px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}

.incyia-user-item:hover {
  background: #f7f9fd;
}

.incyia-user-item-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: #eaeff7;
  color: #5f7484;
  flex-shrink: 0;
}

.incyia-user-item-icon svg {
  font-size: 17px !important;
}

.incyia-user-item:hover .incyia-user-item-icon {
  background: #e2f7f2;
  color: #076b5c;
}

.incyia-user-item.is-danger {
  color: #d14a3e;
}

.incyia-user-item.is-danger .incyia-user-item-icon {
  background: #fae6e3;
  color: #d14a3e;
}

.incyia-user-item.is-danger:hover {
  background: #fae6e3;
}

@keyframes incyia-user-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/userMenu.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;4CAE0C;EAC1C,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,0DAA0D;EAC1D,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* Navbar user menu — INCYIA */\n\n.incyia-user {\n  position: relative;\n  font-family: Lato, sans-serif;\n  flex-shrink: 0;\n}\n\n.incyia-user-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  height: 44px;\n  padding: 0 10px 0 6px;\n  border-radius: 11px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #0b1e2d;\n  cursor: pointer;\n  width: auto !important;\n  transition: background 0.14s, border-color 0.14s, box-shadow 0.14s;\n}\n\n.incyia-user-trigger:hover {\n  background: #f7f9fd;\n  border-color: #dee4f0;\n}\n\n.incyia-user-trigger.is-open {\n  background: #f7f9fd;\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);\n}\n\n.incyia-user-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: #00146d;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n  text-transform: uppercase;\n}\n\n.incyia-user-avatar--lg {\n  width: 40px;\n  height: 40px;\n  font-size: 13px;\n}\n\n.incyia-user-meta {\n  display: none;\n  flex-direction: column;\n  align-items: flex-start;\n  line-height: 1.15;\n  min-width: 0;\n}\n\n@media (min-width: 600px) {\n  .incyia-user-meta {\n    display: flex;\n  }\n}\n\n.incyia-user-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0b1e2d;\n  white-space: nowrap;\n  text-transform: capitalize;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.incyia-user-role {\n  margin-top: 2px;\n  font-size: 12.5px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #5f7484;\n  white-space: nowrap;\n}\n\n.incyia-user-caret {\n  color: #8a9ba7;\n  transition: transform 0.18s ease, color 0.14s;\n  flex-shrink: 0;\n}\n\n.incyia-user-trigger.is-open .incyia-user-caret {\n  transform: rotate(180deg);\n  color: #076b5c;\n}\n\n.incyia-user-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 1400;\n  width: 248px;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 14px;\n  box-shadow:\n    0 1px 2px rgba(6, 21, 36, 0.04),\n    0 18px 44px -22px rgba(0, 20, 109, 0.42);\n  overflow: hidden;\n  animation: incyia-user-in 0.16s ease;\n}\n\n.incyia-user-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 14px 12px;\n  background: linear-gradient(180deg, #f7f9fd 0%, #fff 100%);\n  border-bottom: 1px solid #eaeff7;\n}\n\n.incyia-user-head-copy {\n  min-width: 0;\n}\n\n.incyia-user-head-name {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n  text-transform: capitalize;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.incyia-user-head-role {\n  margin-top: 3px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #076b5c;\n}\n\n.incyia-user-section {\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.incyia-user-foot {\n  padding: 6px;\n  border-top: 1px solid #eaeff7;\n  background: #fafcfd;\n}\n\n.incyia-user-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100% !important;\n  margin: 0;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 600;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s;\n}\n\n.incyia-user-item:hover {\n  background: #f7f9fd;\n}\n\n.incyia-user-item-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  background: #eaeff7;\n  color: #5f7484;\n  flex-shrink: 0;\n}\n\n.incyia-user-item-icon svg {\n  font-size: 17px !important;\n}\n\n.incyia-user-item:hover .incyia-user-item-icon {\n  background: #e2f7f2;\n  color: #076b5c;\n}\n\n.incyia-user-item.is-danger {\n  color: #d14a3e;\n}\n\n.incyia-user-item.is-danger .incyia-user-item-icon {\n  background: #fae6e3;\n  color: #d14a3e;\n}\n\n.incyia-user-item.is-danger:hover {\n  background: #fae6e3;\n}\n\n@keyframes incyia-user-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
